module.exports = __webpack_public_path__ + "static/media/26.47dae0be.mp3";